// @flow
import { REDUCER_KEY } from './reducer';
import type { StdFormsStore } from './types';

export const getStdFormsStore = (state: any): StdFormsStore => state[REDUCER_KEY];
export const getStdFormById = (state: any) => getStdFormsStore(state).stdFormsById;

export const getStdForm = (state: any, id: string) => getStdFormById(state).get(id);
